import {
  LOADING_PLANES,
  SET_ID,
  SET_PLANES,
  SET_DATA_GRUPO,
  SET_GRUPO_PLANES,
  FETCH_GRUPO_BYID,
  FETCH_GRUPO_PLANES,
  SET_DATA_GRUPO_COPY,
  FETCH_PLANES_BYPARAMS,
  FETCH_GRUPO_PLANES_BYID,
  SET_PLANES_DESDE_BUSQUEDA,
  SET_FILTRO_GRUPO_PLANES,
  SET_ID_GRUPO_PLAN,
  RESET_GRUPO_PLANES,
  UPDATE_GRUPO_PLANES_LIST,
  SET_EDITANDO
} from './types';
import {
  getGrupoById,
  getGrupoPlanes,
  getGrupoPlanesById,
  getPlanesPorParametros
} from '../api/axios';

export const setPlanesDesdeBusqueda = (params) => async dispatch => {
  dispatch({
    type: SET_PLANES_DESDE_BUSQUEDA,
    payload: params,
  });
}

export const setPlanes = (params) => async dispatch => {
  dispatch({
    type: SET_PLANES,
    payload: params,
  });
}

export const setIdGrupoPlan = (params) => async dispatch => {
  dispatch({
    type: SET_ID_GRUPO_PLAN,
    payload: params,
  });
}

export const setGrupoPlanes = (params) => async dispatch => {
  dispatch({
    type: SET_GRUPO_PLANES,
    payload: params,
  });
}

export const setId = (params) => async dispatch => {
  dispatch({
    type: SET_ID,
    payload: params,
  });
}

function requestPageSize(req) {
  const p = req?.params ?? req ?? {};
  return p.pageSize ?? p.PageSize ?? p.cantidadPagina;
}

const emptyGrupoPlanesPayload = (req) => ({
  data: {
    elementos: [],
    total: 0,
    page: 1,
    cantidadTotal: 0,
    cantidadPagina: requestPageSize(req) || 10
  }
});

export const fetchGrupoPlanes = (request) => async dispatch => {
  dispatch({
    type: LOADING_PLANES,
    payload: true
  });

  try {
    const value = await getGrupoPlanes(request.params);
    dispatch({
      type: FETCH_GRUPO_PLANES,
      payload: value
    });
  } catch {
    dispatch({
      type: FETCH_GRUPO_PLANES,
      payload: emptyGrupoPlanesPayload(request)
    });
  } finally {
    dispatch({
      type: LOADING_PLANES,
      payload: false
    });
  }
}

export const fetchGrupoPlanesById = (params) => async dispatch => {
  dispatch({
    type: LOADING_PLANES,
    payload: true
  });

  if (params?.idGrupoPlan === 0) {
    dispatch({
      type: FETCH_GRUPO_PLANES_BYID,
      payload: { data: { elementos: [] } }
    });
    dispatch({
      type: LOADING_PLANES,
      payload: false
    });
    return;
  }

  const p = { ...params };
  if (p.idGrupoPlan) {
    p.IdGrupoPlan = p.idGrupoPlan;
    delete p.idGrupoPlan;
  }

  try {
    const value = await getGrupoPlanesById(p);
    dispatch({
      type: FETCH_GRUPO_PLANES_BYID,
      payload: value
    });
  } catch {
    dispatch({
      type: FETCH_GRUPO_PLANES_BYID,
      payload: { data: { elementos: [] } }
    });
  } finally {
    dispatch({
      type: LOADING_PLANES,
      payload: false
    });
  }
}

export const fetchGrupo = (id) => async dispatch => {
  try {
    const value = await getGrupoById(id);
    dispatch({
      type: FETCH_GRUPO_BYID,
      payload: value
    });
  } catch {
    dispatch({
      type: FETCH_GRUPO_BYID,
      payload: { data: {} }
    });
  }
}

export const setDataGrupo = (params) => async dispatch => {
  dispatch({
    type: SET_DATA_GRUPO,
    payload: params,
  });
}

export const setDataGrupoCopy = (params) => async dispatch => {
  dispatch({
    type: SET_DATA_GRUPO_COPY,
    payload: params
  });
}

export const fetchPlanesPorParametros = (params) => async dispatch => {
  let array = getPlanesPorParametros(params);
  array.then((value) => {

    dispatch({
      type: FETCH_PLANES_BYPARAMS,
      payload: value.data
    });
  }).catch(() => {
    dispatch({
      type: FETCH_PLANES_BYPARAMS,
      payload: { elementos: [], cantidadTotal: 0, numeroPagina: 1 }
    });
  })
}

export const setFiltroGrupoPlanes = (filtro) => dispatch => {
  dispatch({
    type: SET_FILTRO_GRUPO_PLANES,
    payload: filtro
  });
}

export const resetGrupoPlanes = () => dispatch => {
  dispatch({
    type: RESET_GRUPO_PLANES,
    payload: []
  });
}

export const updateListGrupoPlanes = (grupoPlanesArray, grupoPlan) => async (dispatch) => {
  //existe un elemento que cumpla con las condiciones
  const existe = grupoPlanesArray.elementos.some(item =>
    item.idGrupoPlan === grupoPlan.idGrupoPlan &&
    (item.descripcion !== grupoPlan.descripcion || item.comision !== grupoPlan.comision)
  );

  if (!existe) {
    return;
  }

  const elementosActualizados = grupoPlanesArray.elementos.map(item =>
    item.idGrupoPlan === grupoPlan.idGrupoPlan ? grupoPlan : item
  );

  const updatedGrupoPlanesArray = {
    ...grupoPlanesArray,
    elementos: elementosActualizados,
  };

  dispatch({
    type: UPDATE_GRUPO_PLANES_LIST,
    payload: updatedGrupoPlanesArray,
  });
}

export const setEditando = (valor) => ({
  type: SET_EDITANDO,
  payload: valor
});
